import { LinkButton } from "./LinkButton";
import "./UpgradePrompt.css";

interface UpgradePromptProps {
  organizationId: string;
  title: string;
  message: string;
}

export function UpgradePrompt({ organizationId, title, message }: UpgradePromptProps) {
  return (
    <div className="upgrade-prompt">
      <div className="upgrade-prompt-content">
        <h3>{title}</h3>
        <p>{message}</p>
        <LinkButton to={`/organizations/${organizationId}/billing`} variant="accent">
          Upgrade to Pro
        </LinkButton>
      </div>
    </div>
  );
}
